'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _ListItem = require('components/ListItem/ListItem');

var _ListItem2 = _interopRequireDefault(_ListItem);

var _Link = require('react-router/lib/Link');

var _Link2 = _interopRequireDefault(_Link);

var _StatisticsRecipientInfoTooltip = require('components/Statistics/StatisticsRecipientInfoTooltip/StatisticsRecipientInfoTooltip');

var _StatisticsRecipientInfoTooltip2 = _interopRequireDefault(_StatisticsRecipientInfoTooltip);

var _YesNoStatus = require('components/YesNoStatus/YesNoStatus');

var _YesNoStatus2 = _interopRequireDefault(_YesNoStatus);

var _RecipientShareLinkButton = require('components/Statistics/RecipientShareLinkButton/RecipientShareLinkButton');

var _RecipientShareLinkButton2 = _interopRequireDefault(_RecipientShareLinkButton);

var _statistics = require('helpers/statistics');

var _ExpiryDate = require('components/ExpiryDate/ExpiryDate');

var _ExpiryDate2 = _interopRequireDefault(_ExpiryDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./CoverageRecipientListItem.scss');

var CoverageRecipientListItem = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(CoverageRecipientListItem, _PureComponent);

  function CoverageRecipientListItem() {
    (0, _classCallCheck3.default)(this, CoverageRecipientListItem);
    return (0, _possibleConstructorReturn3.default)(this, (CoverageRecipientListItem.__proto__ || (0, _getPrototypeOf2.default)(CoverageRecipientListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(CoverageRecipientListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          recipient = _props.recipient,
          columns = _props.columns,
          projectId = _props.projectId;
      var t = this.context.t;


      return _react2.default.createElement(
        _ListItem2.default,
        { className: (0, _bind2.default)(styles.row, className) },
        columns.includes(_statistics.coverageRecipientsColumns.recipientId) && _react2.default.createElement(
          'div',
          null,
          recipient.recipientId
        ),
        columns.includes(_statistics.coverageRecipientsColumns.fullName) && _react2.default.createElement(
          'div',
          null,
          recipient.fullName
        ),
        columns.includes(_statistics.coverageRecipientsColumns.email) && _react2.default.createElement(
          'div',
          null,
          recipient.email
        ),
        columns.includes(_statistics.coverageRecipientsColumns.downloaded) && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_YesNoStatus2.default, {
            success: recipient.downloaded,
            hasRights: recipient.downloadRights
          })
        ),
        columns.includes(_statistics.coverageRecipientsColumns.expiryDate) && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_ExpiryDate2.default, { dateText: recipient.expiryDate, isExpired: recipient.isExpirySoon })
        ),
        columns.includes(_statistics.coverageRecipientsColumns.details) && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _Link2.default,
            { to: '/statistics/project/' + projectId + '/recipient/' + recipient.recipientId },
            t('details')
          )
        ),
        columns.includes(_statistics.coverageRecipientsColumns.info) && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_StatisticsRecipientInfoTooltip2.default, {
            className: styles.infoIcon,
            recipient: recipient
          })
        ),
        columns.includes(_statistics.coverageRecipientsColumns.share) && _react2.default.createElement(
          'div',
          { className: 'text-right' },
          _react2.default.createElement(_RecipientShareLinkButton2.default, { recipientId: recipient.recipientId, projectId: projectId })
        )
      );
    }
  }]);
  return CoverageRecipientListItem;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  columns: _propTypes2.default.array,
  projectId: _propTypes2.default.number,
  recipient: _propTypes2.default.object
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _class.defaultProps = {
  columns: [],
  recipient: {}
}, _temp);
exports.default = CoverageRecipientListItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/CoverageRecipientListItem/CoverageRecipientListItem.js
// module id = 2109
// module chunks = 1